import React from "react";
import { GROUPS, SectionHeading, useEconomyText } from "./shared";

const COST_KEYS = ["payroll", ...GROUPS];

function amount(row) {
  if (!row || row.available === false || row.amount == null || Number.isNaN(Number(row.amount))) return null;
  return Number(row.amount);
}

function projectedOut(projected) {
  if (!projected || COST_KEYS.some((key) => projected[key] == null || Number.isNaN(Number(projected[key])))) return null;
  return Math.round(COST_KEYS.reduce((sum, key) => sum + Number(projected[key]), 0) * 100) / 100;
}

function Figure({ kind, title, detail, value, money, missing }) {
  const known = value != null;
  return <div className={`eco-card eco-kpi${kind === "estimate" ? " eco-kpi-highlight" : ""}`}>
    <span className="eco-label">{title}</span>
    <strong>{known ? money(value) : "—"}</strong>
    <span className="eco-kpi-hint">{known ? detail : missing}</span>
  </div>;
}

export function CashMovement({ source, loading, failed }) {
  const { t, money, monthName } = useEconomyText();
  const period = source
    ? t("throughPeriod", { month: monthName(source.through_month), year: source.year })
    : null;
  const customer = failed ? null : amount(source?.movements?.customer_invoices);
  const supplier = failed ? null : amount(source?.movements?.supplier_invoices);
  const payroll = failed || source?.actual == null ? null : (source.actual.payroll == null ? null : Number(source.actual.payroll));
  const estimatedIn = failed || source?.projected == null || source.projected.revenue == null ? null : Number(source.projected.revenue);
  const estimatedOut = failed ? null : projectedOut(source?.projected);
  return <section className="eco-stack" aria-label={t("cashTitle")}>
    <SectionHeading title={t("cashTitle")} description={t("cashIntro")} />
    {loading && !source && <p className="eco-loading" role="status">{t("loading")}</p>}
    {(!loading || source) && <div className="eco-kpis">
      <Figure kind="actual" title={`${t("actualIn")} · ${t("customerInvoices")}`} detail={period} value={customer} money={money} missing={t("missing")} />
      <Figure kind="estimate" title={`${t("estimatedIn")} · ${t("revenue")}`} detail={t("annualProjection")} value={estimatedIn} money={money} missing={t("missing")} />
      <Figure kind="actual" title={`${t("actualOut")} · ${t("supplierInvoices")}`} detail={period} value={supplier} money={money} missing={t("missing")} />
      <Figure kind="actual" title={`${t("actualOut")} · ${t("bookedPayroll")}`} detail={period} value={Number.isNaN(payroll) ? null : payroll} money={money} missing={t("missing")} />
      <Figure kind="estimate" title={`${t("estimatedOut")} · ${t("cost")}`} detail={t("annualProjection")} value={estimatedOut} money={money} missing={t("missing")} />
    </div>}
  </section>;
}
